// @flow

import React, { Component } from 'react';
import classnames from 'classnames';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Grid } from '@shopify/polaris';

type Props = {
  checked: boolean
};

type ComposedProps = Props & WithI18nProps;

class CollectionHeader1 extends Component<ComposedProps> {
  render() {
    const { i18n, checked } = this.props;
    const CollectionHeaderClass = classnames('collection-header-item collection-header-item-1', {
      active: checked
    });

    return (
      <div className={CollectionHeaderClass}>
        <Grid
          columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
          gap={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }}>
          <Grid.Cell>
            <div className="collection-header-item__content">
              <p className="title">
                {i18n.translate('AdminHTML.ThemeSetting.LayoutModal.collectionHeader_TitleSample')}
              </p>
              <p className="description">
                {i18n.translate(
                  'AdminHTML.ThemeSetting.LayoutModal.collectionHeader_DescriptionSample1'
                )}
                <br />
                {i18n.translate(
                  'AdminHTML.ThemeSetting.LayoutModal.collectionHeader_DescriptionSample2'
                )}
              </p>
            </div>
          </Grid.Cell>
          <Grid.Cell>
            <div className="collection-header-item__bg"></div>
          </Grid.Cell>
        </Grid>
      </div>
    );
  }
}

export default withI18n()(CollectionHeader1);
